module.exports = __webpack_public_path__ + "img/logo.d4efc59d.jpg";